export default "<p>purchases-by-supplier-report works!</p>\r\n";